import React, { useState } from 'react';
import './Header.css';
import { Button } from 'primereact/button';

const Header = (props) => {
  const [isOpen, setIsOpen] = useState(true);

  const toggleHeader = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={`header-container ${isOpen ? 'open' : 'closed'}`}>
      {!isOpen && (
        <Button 
          icon="pi pi-chevron-down" 
          className="toggle-button" 
          onClick={toggleHeader} 
        />
      )}
      {isOpen && (
        <div className="header-content">
           {React.Children.map(props.children, child => 
            React.isValidElement(child)
              ? React.cloneElement(child, { toggleHeader })
              : child
          )}
       
        </div>
      )}
    </div>
  );
};

export default Header;
